<template>
  <!-- 会议室筛选组件 -->
  <van-dropdown-menu class="custom-tree-filter">
    <van-dropdown-item v-if="filterDate" ref="date">
      <template #title>
        <span class="mar-lft-5" :class="dateCN===today?'':'text-danger'">{{dateCN}}</span>
      </template>
      <div class="bord-ver bg-white">
        <!-- 时间筛选 -->
        <van-calendar :poppable="false" :show-title="false" color="#2D69E0"
                      :min-date="minDate" :max-date="maxDate" :formatter="formatDate"
                      :style="{ height:'450px'}" :default-date="date"
                      @confirm="changeDate"></van-calendar>
      </div>
    </van-dropdown-item>
    <!-- 区域筛选 -->
    <van-dropdown-item ref="location">
      <template #title>
        <i class="fa fa-map-marker" :class="locationIds.length ? 'text-danger' : ''">
          <span class="mar-lft-5">区域</span>
        </i>
      </template>
      <div class="bord-ver bg-white">
        <area-filter-cascade :current-areas="locationIds"
                             @change="changeLocations"></area-filter-cascade>
      </div>
    </van-dropdown-item>
    <!-- 容量、类型、审核方式、设备系统 筛选 -->
    <van-dropdown-item ref="filter">
      <template #title>
        <i class="fa fa-filter" :class="Object.keys(destCondition).length ? 'text-danger' : ''">
          <span class="mar-lft-5">筛选</span>
        </i>
      </template>
      <div class="bord-ver bg-white">
        <van-tree-select class="bord-btm"
                         :items="treeList"
                         :main-active-index.sync="active">
          <template #content>
            <div v-for="(item, index) in treeList" :key="item.key">
              <!-- 多选 -->
              <van-checkbox-group v-if="item.multi" v-show="active===index"
                                  v-model="filterRc[item.key]">
                <van-cell-group>
                  <van-cell v-for="(ele, idx) in item.children" clickable :key="ele.value"
                            :title="ele.label" @click="toggleChoice(item.key, idx)">
                    <template #right-icon>
                      <van-checkbox :name="ele.value" :ref="item.key" shape="square" icon-size="14px"></van-checkbox>
                    </template>
                  </van-cell>
                </van-cell-group>
              </van-checkbox-group>

              <!-- 单选 -->
              <van-radio-group v-else v-show="active===index" v-model="filterRc[item.key]">
                <van-cell-group class="bord-no">
                  <van-cell v-for="ele in item.children" :key="ele.value"
                            :title="ele.label" clickable class="bord-no"
                            @click="filterRc[item.key] = ele.value">
                    <template #right-icon>
                      <van-radio :name="ele.value"></van-radio>
                    </template>
                  </van-cell>
                </van-cell-group>
              </van-radio-group>
            </div>
          </template>
        </van-tree-select>

        <van-row gutter="20" class="mar-all">
          <van-col span="12">
            <van-button block size="small" @click="handleSubmit('filter', true)">清除</van-button>
          </van-col>
          <van-col span="12">
            <van-button block size="small" type="primary" @click="handleSubmit('filter')">确定</van-button>
          </van-col>
        </van-row>
      </div>
    </van-dropdown-item>
  </van-dropdown-menu>
</template>

<script>
  import {commonConfig, momentFormat} from "../../../../config/common";
  import AreaFilterCascade from "../../components/AreaFilterCascade";
  import {initSysConfig} from "../../../../tools/utils";

  const filterKeys = {
    locationIds: "locationIds",
    capacityIdx: "capacityIdx",
    types: "types",
    reviewModes: "reviewModes",
    commonlyUsed: "commonlyUsed",
  };
  export default {
    components: {
      AreaFilterCascade
    },
    props: {
      filterDate: Boolean,
      filterDoc: Object,
    },
    data() {
      return {
        active: 0,
        locationIds: [],
        types: [],
        date: null,
        today: moment().format(momentFormat.date),
        filterRc: {
          [filterKeys.capacityIdx]: 0,
          [filterKeys.types]: [],
          [filterKeys.reviewModes]: [],
          [filterKeys.commonlyUsed]: [],
        },
      }
    },
    computed: {
      // 当地时间、时间区间、时间处理
      dateCN() {
        return this.date && moment(this.date).format(momentFormat.date)
      },
      minDate() {
        return moment().startOf('month').toDate()
      },
      maxDate() {
        return moment(this.minDate).add(90, 'd').endOf('month').toDate()
      },
      // 会议室相关信息组装
      roomTypes() {
        const {roomTypes} = this.$store.state.sysConfig;
        return roomTypes || []
      },
      roomLabels() {
        const {roomLabels} = this.$store.state.sysConfig;
        return roomLabels || []
      },
      treeList() {
        const arr = [
          /* {
            text: "常用",
            children: Object.values(commonConfig.commonlyUsedCdt),
            dot: Boolean(this.filterRc.commonlyUsed.length),
            key: filterKeys.commonlyUsed,
            multi: true
          }, */
          {
            text: "容量",
            children: Object.values(commonConfig.capacityChoices),
            dot: Boolean(this.filterRc.capacityIdx),
            key: filterKeys.capacityIdx,
          }
        ];
        if (this.roomTypes.length) {
          arr.push({
            text: "类型",
            children: this.roomTypes,
            dot: Boolean(this.filterRc.types.length),
            key: filterKeys.types,
            multi: true
          })
        }
        arr.push({
          key: filterKeys.reviewModes,
          text: "审核方式",
          children: Object.values(commonConfig.reviewModes),
          dot: Boolean(this.filterRc.reviewModes.length),
          multi: true
        });
        this.roomLabels.forEach((info, idx) => {
          const key = `label_${idx}`;
          arr.push({
            text: info.label,
            children: info.values,
            dot: Boolean(this.filterRc[key] && this.filterRc[key].length),
            key,
            multi: true
          })
        });
        return arr
      },
      locationList() {
        const {locationList} = this.$store.state.sysConfig;
        return (locationList || []).map(e => ({
          label: e.name, value: e.id
        }))
      },
      destCondition() {
        const condition = {};
        this.treeList.forEach(item => {
          switch (item.key) {
            case filterKeys.commonlyUsed:
              this.filterRc.commonlyUsed.forEach(val => {
                switch (val) {
                  case commonConfig.commonlyUsedCdt.matchDeptRooms.value:
                    condition.matchDeptRooms = true;
                    break;
                  default:
                    break
                }
              });
              return;
            case filterKeys.capacityIdx:
              if (this.filterRc.capacityIdx) {
                const capacityInfo = Object.values(commonConfig.capacityChoices).find(e => e.value === this.filterRc.capacityIdx);
                if (capacityInfo) {
                  const {min, max} = capacityInfo;
                  condition.capacityRange = {min, max}
                }
              }
              return;
            case filterKeys.types:
              if (this.filterRc.types.length) {
                condition.roomTypes = this.filterRc.types;
              }
              return;
            default:
              if (filterKeys.hasOwnProperty(item.key)) {
                if (this.filterRc[item.key].length) {
                  condition[[item.key]] = this.filterRc[item.key];
                }
                return;
              }
              break;
          }
          // 余下是labels处理
          if (this.filterRc[item.key] && this.filterRc[item.key].length) {
            condition.roomLabels = (condition.roomLabels || []).concat(this.filterRc[item.key])
          }
        });
        // console.log(condition.roomLabels)
        return condition
      }
    },
    created() {
      initSysConfig.call(this, () => {
        this.initFilterRc()
      })
    },
    methods: {
      // 初始化筛选数据
      initFilterRc() {
        if (this.filterDoc) {
          this.date = this.filterDoc.date && moment(this.filterDoc.date).toDate();
          if (this.filterDoc.locationIds) {
            this.locationIds = this.filterDoc.locationIds;
          }
          const filterRc = {};
          if (this.filterDoc.matchDeptRooms) {
            filterRc.commonlyUsed = [commonConfig.commonlyUsedCdt.matchDeptRooms.value]
          }
          if (this.filterDoc.capacityRange) {
            const {min, max} = this.filterDoc.capacityRange;
            const capacityInfo = Object.values(commonConfig.capacityChoices).find(e => {
              return e.min === min && e.max === max
            });
            if (capacityInfo) {
              filterRc.capacityIdx = capacityInfo.value
            }
          }
          if (this.filterDoc.roomTypes) {
            filterRc.types = this.filterDoc.roomTypes
          }
          if (this.filterDoc.reviewModes) {
            filterRc.reviewModes = this.filterDoc.reviewModes
          }
          if (this.filterDoc.roomLabels) {
            const tmp = {};
            this.filterDoc.roomLabels.forEach(val => {
              const lbInfo = this.roomLabels.find(e => e.values.some(i => i.value === val));
              if (lbInfo) {
                tmp[lbInfo.label] = (tmp[lbInfo.label] || []).concat(val)
              }
            });
            Object.keys(tmp).forEach(label => {
              const labelDoc = this.treeList.find(e => e.text === label);
              if (labelDoc) {
                filterRc[labelDoc.key] = tmp[label]
              }
            })
          }
          this.filterRc = {
            ...this.filterRc,
            ...filterRc
          }
        }
      },
      toggleChoice(key, index) {
        this.$refs[key][index].toggle()
      },
      // 改变区域
      changeLocations(data) {
        // console.log(data)
        this.locationIds = data;
        this.handleSubmit('location')
      },
      // 日期变化
      changeDate(date) {
        // console.log(moment(date).format(momentFormat.date))
        this.date = date;
        this.handleSubmit('date')
      },
      // 提交至父组件
      handleSubmit(key, clear) {
        // console.log(this.filterRc);
        if (clear) {
          switch (key) {
            case 'date':
              this.date = null;
              break;
            case 'location':
              this.locationIds = [];
              break;
            case 'filter':
              this.filterRc = {
                [filterKeys.capacityIdx]: 0,
                [filterKeys.types]: [],
                [filterKeys.reviewModes]: [],
                [filterKeys.commonlyUsed]: [],
              };
              break;
            default:
          }
          return
        }
        this.$refs[key].toggle();
        const condition = {...this.destCondition};
        if (this.locationIds.length) {
          condition.locationIds = this.locationIds
        }
        if (this.filterDate) {
          condition.date = this.date.valueOf()
        }
        // console.log(condition);
        this.$emit('handle-filter', condition)
      },

      formatDate(day) {
        if (moment(day.date).format(momentFormat.date) === this.today) {
          day.bottomInfo = '今天';
        }
        return day
      },
    },
  }
</script>

<style lang="less">
  .custom-tree-filter {
    .van-dropdown-menu__bar {
      height: 35px !important;
    }

    .van-dropdown-menu__title {
      font-size: 13px;
    }

    .van-popup .van-button {
      border: 1px solid #ebedf0;
    }

    .van-popup .van-cell::after {
      border-bottom: 1px solid #ebedf0;
    }
  }
</style>
